import styled from "styled-components"

const SignUp = styled.div`
    width:30vw;
    margin:0 auto;
    display:flex;
    flex-direction:column;
    .button{
        display:flex;
        flex-direction:column;
    }
    @media(max-width:400px){
        width:80vw;
    }
`

export default SignUp